import Axios from '@/utils/axios';

const AuthService = {
  login: async (identifier: string, credential: string) => {
    const response = await Axios.post('/client-user/v1/auth/login', {
      identifier,
      credential,
      provider: 'EMAIL_PASSWORD',
    });
    const token = response.data.data.accessToken;
    localStorage.setItem('token', token);
    return token;
  },

  getMe: async () => {
    const response = await Axios.get('/client-user/v1/users/me');
    return response.data.data;
  },

  logout: () => {
    localStorage.clear();
    window.location.href = '/signin';
  },

  getToken: () => localStorage.getItem('token'),

  isAuthenticated: () => !!AuthService.getToken(),
};

export default AuthService;
